module.exports = __webpack_public_path__ + "media/CN_002.1f28d765.mp3";